<script setup lang="ts">
import { PaginationData } from '@/@types/order'
import { Button } from '@/components/ui/button'

import {
    Pagination,
    PaginationContent,
    PaginationEllipsis,
    PaginationFirst,
    PaginationItem,
    PaginationLast,
    PaginationNext,
    PaginationPrevious,
} from '@/components/ui/pagination'
import { Link, router } from '@inertiajs/vue3'
import { computed, watch } from 'vue'

const props = defineProps<{
    pagination: PaginationData
    params: {
        query?: string
        status?: string
        category?: string
        workshop?: string
    }
}>()

const currentPage = computed({
    get: () => props.pagination.current_page,
    set: (val) => {
        props.pagination.current_page = val
    },
})

watch(currentPage, () => {
    router.reload({
        data: {
            page: currentPage.value,
        },
    })
})

const couponParams = computed(
    () =>
        `${props.params?.query ? `query=${props.params.query}&` : ''}${props.params?.status ? `status=${props.params.status}&` : ''}${props.params?.category ? `category=${props.params.category}&` : ''}${props.params?.workshop ? `workshop=${props.params.workshop}` : ''}`,
)
</script>

<template>
    <Pagination v-slot="{ page }" :items-per-page="pagination.per_page" :total="pagination.total" show-edges :default-page="currentPage">
        <PaginationContent v-slot="{ items }" class="flex items-center gap-1">
            <PaginationFirst @click="currentPage = 1" />
            <PaginationPrevious @click="currentPage--" />

            <template v-for="(item, index) in items">
                <PaginationItem v-if="item.type === 'page'" :key="index" :value="item.value" as-child>
                    <Button
                        :as="Link"
                        :href="`/coupons?page=${item.value}&${couponParams}`"
                        class="h-9 w-9 p-0"
                        :variant="item.value === page ? 'default' : 'outline'"
                    >
                        {{ item.value }}
                    </Button>
                </PaginationItem>
                <PaginationEllipsis v-else :key="item.type" :index="index" />
            </template>

            <PaginationNext @click="currentPage++" />
            <PaginationLast @click="currentPage = pagination.last_page" />
        </PaginationContent>
    </Pagination>
</template>
